module.exports = __webpack_public_path__ + "static/the-varieties-of-religious-experience-39d19013cb386261eccd0a8a1645b7dd.jpg";